import { toast } from "react-toastify";
import { Box } from "../components/Box";
import { Flex } from "../components/Flex";
import "./showSessionExpiryToast.css";
import React, { useEffect, useState } from "react";

export const showSessionExpiryToast = (
  countdown: number,
  onStayLoggedIn: () => void,
  onLogout: () => void
) => {
  if (!toast.isActive("session-expiry")) {
    toast.info(
      <SessionExpiryToast
        initialCountdown={countdown}
        onStayLoggedIn={onStayLoggedIn}
        onLogout={onLogout}
      />,
      {
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        position: "bottom-left",
        toastId: "session-expiry",
        className: "bg-blue-600 rounded-lg custom-toast",
      }
    );
  }
};

const SessionExpiryToast = ({
  initialCountdown,
  onStayLoggedIn,
  onLogout,
}: {
  initialCountdown: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}) => {
  const [countdown, setCountdown] = useState(initialCountdown);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Flex justifyContent={"space-between"} alignItems="center" gap="16">
      <Box flex={1.3}>
        <p style={{ fontSize: "14px" }} className="font-semibold text-white">
          Session Expiring Soon
        </p>
        <p
          style={{ fontSize: "12px", color: "#B0B7C5" }}
          className="text-sm text-white"
        >
          Your session will expire in ({countdown}) seconds.
          <br />
          Click "Stay logged in" to remain signed in.
        </p>
      </Box>
      <Box flex={0.7}>
        <Flex
          justifyContent={"space-between"}
          alignItems="center"
          flexDirection={"column"}
        >
          <button onClick={onStayLoggedIn} className="primary-button">
            Stay Logged In
          </button>
          <button onClick={onLogout} className="button-text">
            Log Out
          </button>
        </Flex>
      </Box>
    </Flex>
  );
};
